// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"a731c35e","182":"3abff638","235":"8d6aaf13","484":"14cb0921","551":"8912905c","957":"8875547d"}[chunkId] + ".chunk.js";
};